import { Navigate, Outlet } from 'react-router-dom';
import { hasAdminAccess, useAuth } from 'utils/auth';
import SessionStatus from './SessionStatus';
import AppBar from 'components/AppBar';

interface Props {
  redirectPath?: any;
  children?: any;
}

export default function ProtectedRoute({
  redirectPath = '/login',
  children
}: Props) {
  const auth = useAuth();
  if (!auth.ready) return <SessionStatus />;
  if (!hasAdminAccess(auth.user)) {
    return <Navigate to={redirectPath} replace />;
  }

  return children ? (
    <>
      <AppBar /> {children}
    </>
  ) : (
    <>
      <AppBar />
      <Outlet />
    </>
  );
}
